import { SpecificChartFunctionality } from '../../constants/common'
import ChartLayoutModel from '../../models/chart_layout'

export function getChartLayoutPositions(model: ChartLayoutModel) {
  const { settingsHeight } = model.settings.ChartSettings.general
  const charts = model.charts().all()
  const chartTopOffset = model.specificChartFunctionality === SpecificChartFunctionality.chartPage ? settingsHeight : 0

  switch (model.layout) {
    case '1h2v':
      return [
        { x: 0, y: chartTopOffset },
        { x: 0, y: charts[0].height + chartTopOffset * 2 },
      ]
    case '2h1v':
      return [
        { x: 0, y: chartTopOffset },
        { x: charts[0].width, y: chartTopOffset },
      ]
    case '1h3v':
      return [
        { x: 0, y: chartTopOffset },
        { x: 0, y: charts[0].height + chartTopOffset * 2 },
        { x: 0, y: charts[0].height + charts[1].height + chartTopOffset * 3 },
      ]
    case '3h1v':
      return [
        { x: 0, y: chartTopOffset },
        { x: charts[0].width, y: chartTopOffset },
        { x: charts[0].width + charts[1].width, y: chartTopOffset },
      ]
    case '2h2v':
      return [
        { x: 0, y: chartTopOffset },
        { x: charts[0].width, y: chartTopOffset },
        { x: 0, y: charts[0].height + chartTopOffset * 2 },
        { x: charts[2].width, y: charts[1].height + chartTopOffset * 2 },
      ]
    case '3h2v':
      return [
        { x: 0, y: chartTopOffset },
        { x: charts[0].width, y: chartTopOffset },
        { x: charts[0].width + charts[1].width, y: chartTopOffset },
        { x: 0, y: charts[0].height + chartTopOffset * 2 },
        { x: charts[3].width, y: charts[1].height + chartTopOffset * 2 },
        { x: charts[3].width + charts[4].width, y: charts[2].height + chartTopOffset * 2 },
      ]
    case '1l2r':
      return [
        { x: 0, y: chartTopOffset },
        { x: charts[0].width, y: chartTopOffset },
        {
          x: charts[0].width,
          y: charts[1].height + chartTopOffset * 2,
        },
      ]
    case '1t2b':
      return [
        { x: 0, y: chartTopOffset },
        { x: 0, y: charts[1].height + chartTopOffset * 2 },
        { x: charts[1].width, y: charts[1].height + chartTopOffset * 2 },
      ]
    default:
      // 1h1v
      return [{ x: 0, y: chartTopOffset }]
  }
}
